import { forwardRef, useEffect, useState } from "react";
import { HexColorInput, HexColorPicker } from "react-colorful";
import Textfield from "./Textfield";
import { cn } from "@/shared/utils/cn";

interface IProps {
  name: string;
  value: string;
  refP?: any;
  errors: any;
  onChange: (color: string) => void;
  label?: string;
  hideTextfield?: boolean;
  showLabel?: boolean;
}

const InputColor = forwardRef<HTMLInputElement, any>(
  (
    {
      hideTextfield = false,
      name,
      value,
      onChange,
      errors,
      label,
      showLabel = false,
    }: IProps,
    ref: any
  ) => {
    const [color, setColor] = useState(value);
    const [showColorPicker, setShowColorPicker] = useState(false);
    useEffect(() => {
      setColor(value);
    }, [value]);

    const handleChangeColorPicker = (color) => {
      setColor(color);
      if (onChange) {
        onChange(color);
      }
    };

    const handleChangeTextfield = (event) => {
      setColor(event.target.value);
      if (onChange) {
        onChange(event.target.value);
      }
    };

    return (
      <>
        {(showLabel || (label && !hideTextfield)) && (
          <div
            className="font-semibold md:mb-[1.35rem]"
            style={{ marginBottom: undefined }}
          >
            {label}
          </div>
        )}

        <div className="relative flex">
          <div
            onClick={() => setShowColorPicker(!showColorPicker)}
            className="rounded-[4px] inline-block cursor-pointer"
          >
            <div
              className="w-[35px] h-[35px] rounded-[4px] border-1 border-primary-dark"
              style={{
                backgroundColor:
                  color?.length === 4 || color?.length === 7 ? color : "#000",
              }}
            />
          </div>
          {showColorPicker ? (
            <div className="absolute left-0 top-10 z-2 md:-left-20">
              <div
                onClick={() => setShowColorPicker(false)}
                className="fixed top-0 left-0 right-0 bottom-0"
              />
              <div className="relative w-80 rounded-xl bg-white p-2 shadow-[0_10px_25px_rgba(0,0,0,0.1)]">
                <HexColorPicker
                  color={color}
                  onChange={handleChangeColorPicker}
                  className="custom-picker"
                />
                <HexColorInput
                  color={color}
                  onChange={handleChangeColorPicker}
                  prefixed
                  className="mt-2 w-full rounded-[4px] border border-primary-dark px-2 py-1 uppercase outline-none"
                />
              </div>
            </div>
          ) : null}
          <div className={cn("mr-2.5", hideTextfield ? "hidden" : "block")}>
            <Textfield
              autoComplete="off"
              defaultValue={value}
              type="text"
              error={errors?.[name]?.message}
              ref={ref}
              name={name}
              onChange={handleChangeTextfield}
              width="125px"
            />
          </div>
        </div>
      </>
    );
  }
);

export default InputColor;
